import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaptainInformationComponent } from './captain-information.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from '../../../../../../shared/loading/loading.module';
import { VesselSaveButtonModule } from '../../vessel-save-button/vessel-save-button.module';
import { AsyncButtonModule } from '../../../../../../shared/directives/async-button/async-button.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    LoadingModule,
    VesselSaveButtonModule,
    AsyncButtonModule,
  ],
  declarations: [CaptainInformationComponent],
  exports: [CaptainInformationComponent],
})
export class CaptainInformationModule {}
